import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, concatMap, map, mergeMap, switchMap, withLatestFrom } from "rxjs/operators";

import { CarRefActions } from "../actions/carref.actions";
import { CarEngine } from "src/app/public/car/models/car-engine.model";
import { CarFeature } from "src/app/public/car/models/car-feature.model";
import { CarJobTask } from "src/app/public/car/models/car-job-task.model";
import { CarJobTemplate } from "src/app/public/car/models/car-job-template.model";
import { CarMake } from "src/app/public/car/models/car-make.model";
import { CarManufacturer } from "src/app/public/car/models/car-manufacturer.model";
import { CarModel } from "src/app/public/car/models/car-model.model";
import { CarVersion } from "src/app/public/car/models/car-version.model";
import { CarRefService } from "src/app/public/car/services/carref.service";

@Injectable()
export class CarRefApiEffects{

    constructor(
        private carRefService: CarRefService,
        private actions$: Actions
    ){}
    

    //Manufacturers
    addNewManufacturer$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.manufacturerNewSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .addNewManufacturer (action.manufacturer)
                    .pipe( 
                        map( (result: CarManufacturer) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.manufacturerNewSuccess ( { manufacturer: result } );
                            })
                        )
            })
        )
    });

    updateManufacturer$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.manufacturerUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateManufacturer (action.manufacturer)
                    .pipe( 
                        map( (result: CarManufacturer) => { 
                            
                                return CarRefActions.manufacturerUpdateSuccess ( { manufacturer: result } );
                            })
                        )
            })
        )
    });

    updateManufacturerStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.manufacturerStatusUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateManufacturerStatus (action.manufacturerId, action.status)
                    .pipe( 
                        map( (result: CarManufacturer) => { 
                            
                                return CarRefActions.manufacturerUpdateSuccess ( { manufacturer: result } );
                            })
                        )
            })
        )
    });

    deleteManufacturer$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.manufacturerDeleteSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .deleteManufacturer (action.manufacturerId)
                    .pipe( 
                        map( (id: number) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.manufacturerDeleteSuccess ( {manufacturerId: id } );
                            })
                        )
            })
        )
    });

    fetchManufacturers$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.manufacturersFetchSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .fetchManufacturers ()
                    .pipe( 
                        map( (res: any) => { 
                            return CarRefActions.manufacturersFetchSuccess( {manufacturers: res} );
                            })
                        )
            })
        )
    });


        

    //Makes
    addNewMake$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.makeNewSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .addNewMake (action.make)
                    .pipe( 
                        map( (result: CarMake) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.makeNewSuccess ( { make: result } );
                            })
                        )
            })
        )
    });

    updateMake$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.makeUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateMake (action.make)
                    .pipe( 
                        map( (result: CarMake) => { 
                            
                                return CarRefActions.makeUpdateSuccess ( { make: result } );
                            })
                        )
            })
        )
    });

    updateMakeStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.makeStatusUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateMakeStatus (action.makeId, action.status)
                    .pipe( 
                        map( (result: CarMake) => { 
                            
                                return CarRefActions.makeUpdateSuccess ( { make: result } );
                            })
                        )
            })
        )
    });

    deleteMake$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.makeDeleteSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .deleteMake (action.makeId)
                    .pipe( 
                        map( (id: number) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.makeDeleteSuccess ( {makeId: id } );
                            })
                        )
            })
        )
    });

    fetchMakes$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.makesFetchSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .fetchMakes (action.manufacturerIds)
                    .pipe( 
                        map( (res: any) => { 
                            return CarRefActions.makesFetchSuccess( {makes: res} );
                            })
                        )
            })
        )
    });


        

    //Models
    addNewModel$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.modelNewSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .addNewModel (action.model)
                    .pipe( 
                        map( (result: CarModel) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.modelNewSuccess ( { model: result } );
                            })
                        )
            })
        )
    });

    updateModel$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.modelUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateModel (action.model)
                    .pipe( 
                        map( (result: CarModel) => { 
                            
                                return CarRefActions.modelUpdateSuccess ( { model: result } );
                            })
                        )
            })
        )
    });

    updateModelStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.modelStatusUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateModelStatus (action.modelId, action.status)
                    .pipe( 
                        map( (result: CarModel) => { 
                            
                                return CarRefActions.modelUpdateSuccess ( { model: result } );
                            })
                        )
            })
        )
    });

    deleteModel$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.modelDeleteSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .deleteModel (action.modelId)
                    .pipe( 
                        map( (id: number) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.modelDeleteSuccess ( {modelId: id } );
                            })
                        )
            })
        )
    });

    fetchModels$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.modelsFetchSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .fetchModels (action.makeIds)
                    .pipe( 
                        map( (res: any) => { 
                            return CarRefActions.modelsFetchSuccess( {models: res} );
                            })
                        )
            })
        )
    });


        

    //Versions
    addNewVersion$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.versionNewSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .addNewVersion (action.version)
                    .pipe( 
                        map( (result: CarVersion) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.versionNewSuccess ( { version: result } );
                            })
                        )
            })
        )
    });

    updateVersion$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.versionUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateVersion (action.version)
                    .pipe( 
                        map( (result: CarVersion) => { 
                            
                                return CarRefActions.versionUpdateSuccess ( { version: result } );
                            })
                        )
            })
        )
    });

    updateVersionStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.versionStatusUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateVersionStatus (action.versionId, action.status)
                    .pipe( 
                        map( (result: CarVersion) => { 
                            
                                return CarRefActions.versionUpdateSuccess ( { version: result } );
                            })
                        )
            })
        )
    });

    deleteVersion$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.versionDeleteSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .deleteVersion (action.versionId)
                    .pipe( 
                        map( (id: number) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.versionDeleteSuccess ( {versionId: id } );
                            })
                        )
            })
        )
    });

    fetchVersions$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.versionsFetchSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .fetchVersions (action.modelIds)
                    .pipe( 
                        map( (res: any) => { 
                            return CarRefActions.versionsFetchSuccess( {versions: res} );
                            })
                        )
            })
        )
    });


    
    //Engines
    addNewEngine$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.engineNewSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .addNewEngine (action.engine)
                    .pipe( 
                        map( (result: CarEngine) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.engineNewSuccess ( { engine: result } );
                            })
                        )
            })
        )
    });

    updateEngine$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.engineUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateEngine (action.engine)
                    .pipe( 
                        map( (result: CarEngine) => { 
                            
                                return CarRefActions.engineUpdateSuccess ( { engine: result } );
                            })
                        )
            })
        )
    });

    updateEngineStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.engineStatusUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateEngineStatus (action.engineId, action.status)
                    .pipe( 
                        map( (result: CarEngine) => { 
                            
                                return CarRefActions.engineUpdateSuccess ( { engine: result } );
                            })
                        )
            })
        )
    });

    deleteEngine$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.engineDeleteSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .deleteEngine (action.engineId)
                    .pipe( 
                        map( (id: number) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.engineDeleteSuccess ( {engineId: id } );
                            })
                        )
            })
        )
    });

    fetchEngines$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.enginesFetchSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .fetchEngines (action.manufacturerIds)
                    .pipe( 
                        map( (res: any) => { 
                            return CarRefActions.enginesFetchSuccess( {engines: res} );
                            })
                        )
            })
        )
    });



    //Features
    addNewFeature$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.featureNewSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .addNewFeature (action.feature)
                    .pipe( 
                        map( (result: CarFeature) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.featureNewSuccess ( { feature: result } );
                            })
                        )
            })
        )
    });

    updateFeature$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.featureUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateFeature (action.feature)
                    .pipe( 
                        map( (result: CarFeature) => { 
                            
                                return CarRefActions.featureUpdateSuccess ( { feature: result } );
                            })
                        )
            })
        )
    });

    updateFeatureStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.featureStatusUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateFeatureStatus (action.featureId, action.status)
                    .pipe( 
                        map( (result: CarFeature) => { 
                            
                                return CarRefActions.featureUpdateSuccess ( { feature: result } );
                            })
                        )
            })
        )
    });

    deleteFeature$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.featureDeleteSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .deleteFeature (action.featureId)
                    .pipe( 
                        map( (id: number) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.featureDeleteSuccess ( {featureId: id } );
                            })
                        )
            })
        )
    });

    fetchFeatures$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.featuresFetchSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .fetchFeatures ()
                    .pipe( 
                        map( (res: any) => { 
                            return CarRefActions.featuresFetchSuccess( {features: res} );
                            })
                        )
            })
        )
    });



    //JobTemplates
    addNewJobTemplate$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTemplateNewSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .addNewJobTemplate (action.jobTemplate)
                    .pipe( 
                        map( (result: CarJobTemplate) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.jobTemplateNewSuccess ( { jobTemplate: result } );
                            })
                        )
            })
        )
    });

    updateJobTemplate$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTemplateUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateJobTemplate (action.jobTemplate)
                    .pipe( 
                        map( (result: CarJobTemplate) => { 
                            
                                return CarRefActions.jobTemplateUpdateSuccess ( { jobTemplate: result } );
                            })
                        )
            })
        )
    });

    updateJobTemplateStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTemplateStatusUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateJobTemplateStatus (action.jobTemplateId, action.status)
                    .pipe( 
                        map( (result: CarJobTemplate) => { 
                            
                                return CarRefActions.jobTemplateUpdateSuccess ( { jobTemplate: result } );
                            })
                        )
            })
        )
    });

    deleteJobTemplate$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTemplateDeleteSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .deleteJobTemplate (action.jobTemplateId)
                    .pipe( 
                        map( (id: number) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.jobTemplateDeleteSuccess ( {jobTemplateId: id } );
                            })
                        )
            })
        )
    });

    fetchJobTemplates$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTemplatesFetchSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .fetchJobTemplates ()
                    .pipe( 
                        map( (res: any) => { 
                            return CarRefActions.jobTemplatesFetchSuccess( {jobTemplates: res} );
                            })
                        )
            })
        )
    });



    
    //JobTasks
    addNewJobTask$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTaskNewSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .addNewJobTask (action.jobTask)
                    .pipe( 
                        map( (result: CarJobTask) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.jobTaskNewSuccess ( { jobTask: result } );
                            })
                        )
            })
        )
    });

    updateJobTask$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTaskUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateJobTask (action.jobTask)
                    .pipe( 
                        map( (result: CarJobTask) => { 
                            
                                return CarRefActions.jobTaskUpdateSuccess ( { jobTask: result } );
                            })
                        )
            })
        )
    });

    updateJobTaskStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTaskStatusUpdateSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .updateJobTaskStatus (action.jobTaskId, action.status)
                    .pipe( 
                        map( (result: CarJobTask) => { 
                            
                                return CarRefActions.jobTaskUpdateSuccess ( { jobTask: result } );
                            })
                        )
            })
        )
    });

    deleteJobTask$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTaskDeleteSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .deleteJobTask (action.jobTaskId)
                    .pipe( 
                        map( (id: number) => { 
                            //if(carCriteria !== null)
                                return CarRefActions.jobTaskDeleteSuccess ( {jobTaskId: id } );
                            })
                        )
            })
        )
    });

    fetchJobTasks$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CarRefActions.jobTasksFetchSubmit),
            concatMap( (action) => {
                return this.carRefService
                    .fetchJobTasks ()
                    .pipe( 
                        map( (res: any) => { 
                            return CarRefActions.jobTasksFetchSuccess( {jobTasks: res} );
                            })
                        )
            })
        )
    });
  
  
}